const colors = {
  LIGHTPRIMARY: "#f59e0b",
  LIGHTSECONDARY: "#64748b",
  LIGHTBG: "#f1f5f9",
  LIGHTTEXT: "#6c757d",
  LIGHTCARDBG: "whitesmoke",
  DARKPRIMARY: "#fbbf24",
  DARKSECONDARY: "#9ca3af",
  DARKBG: "#303030",
  DARKTEXT: "#d1d0d0",
  DARKCARDBG: "#424242",
}

export const THEME = {
  light: {
    "--primary": colors.LIGHTPRIMARY,
    "--secondary": colors.LIGHTSECONDARY,
    "--background": colors.LIGHTBG,
    "--text": colors.LIGHTTEXT,
    "--cardBg": colors.LIGHTCARDBG,
    "--shadow": "0, 0, 0",
    "--shadowSecondary": "245, 158, 11",
    "--shadowTertiary": "100, 116, 139",
  },
  dark: {
    "--primary": colors.DARKPRIMARY,
    "--secondary": colors.DARKSECONDARY,
    "--background": colors.DARKBG,
    "--text": colors.DARKTEXT,
    "--cardBg": colors.DARKCARDBG,
    "--shadow": "255, 255, 255",
    "--shadowSecondary": "251, 191, 36",
    "--shadowTertiary": "156, 163, 175",
  },
}
